import { Card } from "./card";
import { children, type Child } from "../_data/mock";

const childRing = {
  orange:
    "ring-[var(--child-1-primary)] bg-[var(--child-1-light)] text-[var(--child-1-primary)]",
  blue: "ring-[var(--child-2-primary)] bg-[var(--child-2-light)] text-[var(--child-2-primary)]",
} as const;

export function ChildPicker({
  value,
  onChange,
}: {
  value: Child["id"];
  onChange: (id: Child["id"]) => void;
}) {
  return (
    <Card title="Patient">
      <ul className="flex flex-wrap gap-2 pt-1">
        {children.map((c) => {
          const selected = value === c.id;
          return (
            <li key={c.id}>
              <button
                type="button"
                onClick={() => onChange(c.id)}
                className={`inline-flex h-10 items-center rounded-full px-4 text-[14px] font-semibold ring-1 transition ${selected ? childRing[c.color] : "bg-[var(--surface-1)] text-[var(--text-2)] ring-[var(--border-1)]"}`}
              >
                {c.firstName}
              </button>
            </li>
          );
        })}
      </ul>
    </Card>
  );
}
